<template>
  <div class="row">
    <div class="col-12">
      <div class="new-button-div">
        <n-button @click.native="openItemAdd()" type="primary" round>
          <i slot="label" class="now-ui-icons ui-1_simple-add"></i>
          {{ $t("app.buttons.new") }}
        </n-button>
      </div>

      <card card-body-classes="table-full-width" no-footer-line>
        <div>
          <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">

            <h4 class="card-title text-purple">{{ $t("app.modules.product_family_prop.title") }}</h4>

            <fg-input>
              <el-input
                type="search"
                class="mb-3"
                clearable
                prefix-icon="el-icon-search "
                style="width: 300px;"
                :placeholder="$t('app.general.search')"
                v-model="searchQuery"
                aria-controls="datatables">
              </el-input>
            </fg-input>

          </div>

          <el-table stripe style="width: 100%;" :data="queriedData">

            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :minWidth="column.minWidth"
              :prop="column.prop"
              :label="$t(column.label)"
              :className="column.className"
              sortable
            >
            </el-table-column>

            <el-table-column
              className="is-center"
              labelClassName="is-center"
              :label="$t('app.modules.product_family_prop.headers.content_type')"
              minWidth="200"
            >
              <template slot-scope="scope">

                {{ $t('app.modules.product_family_prop.headers.'+scope.row.tipo) }}

              </template>
            </el-table-column>

            <el-table-column
              className="is-center"
              labelClassName="is-center"
              :label="$t('app.modules.product_family_prop.headers.status')"
              minWidth="160"
            >
              <template slot-scope="scope">

                <n-switch v-model="scope.row.activo" @input="active(scope.row)" color="black">
                  <i class="now-ui-icons ui-1_check" slot="on"></i>
                  <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                </n-switch>

              </template>
            </el-table-column>

            <el-table-column
              :minWidth="200"
              fixed="right"
              className="is-center"
              labelClassName="is-center">

              <div slot-scope="scope" class="table-actions dropdown">
                <el-popover
                  placement="bottom"
                  width="250"
                  trigger="click"
                >

                  <div class="row">
                    <div class="col-12 options">
                      <n-button
                        @click.native="openItemEdit(scope.row)"
                        class="options-button"
                        type="primary"
                        size="sm">
                        {{ $t('app.buttons.edit') }}
                      </n-button>

                      <!--<n-button v-if="scope.row.activo"
                                class="options-button"
                                type="default"
                                round
                                size="sm">
                        {{ $t('app.buttons.deactivate') }}
                      </n-button>
                      <n-button v-else
                                class="options-button"
                                type="primary"
                                round
                                size="sm">
                        {{ $t('app.buttons.activate') }}
                      </n-button>-->

                    </div>
                  </div>

                  <n-button
                    slot="reference"
                    size="sm"
                    icon
                    style="background-color:white;">
                    <i class="fa fa-ellipsis-v" style="color:black;"></i>
                  </n-button>

                </el-popover>
              </div>
            </el-table-column>
          </el-table>

        </div>

        <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <div class="">
            <p class="card-category">
              {{ $t("app.pagination.showing") }} {{ from + 1 }} {{ $t("app.pagination.of") }} {{ to }} {{ $t("app.pagination.of") }} {{ total }} {{ $t("app.pagination.records") }}
            </p>
          </div>
          <n-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total">
          </n-pagination>
        </div>
      </card>
      <propiedad-familia-producto-add></propiedad-familia-producto-add>
    </div>
  </div>
</template>

<script>
import {Pagination as NPagination} from "src/components";
import {mapState} from "vuex";
import {getResponse} from "@/util/utilities";
import Fuse from "fuse.js";

export default {
  components: {
    NPagination,
    PropiedadFamiliaProductoAdd: () => import("./propiedadFamiliaProductoAdd")
  },
  created () {

  },
  computed: {
    ...mapState(["user"]),

    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }

  },
  data() {
    return {
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      propsToSearch: ["nombrePropiedad"],
      tableColumns: [
        {
          prop: "nombrePropiedad",
          label: "app.modules.product_family_prop.headers.name",
          minWidth: 200
        },
        {
          prop: "grupoPropiedadFamiliaProducto.nombreGrupo",
          label: "app.modules.product_family_prop.headers.group_name",
          minWidth: 180
        }
      ],
      searchQuery: "",
      tableData: [],
      searchedData: []
    };
  },
  methods: {
    async init() {
      let self = this;
      this.$swal.fire({
        title: self.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      var payload = {
        id: 0,
        claveIdioma: this.$store.state.lang,
        usuario: 0
      };

      let request = await this.$http.post(route("PropiedadFamiliaProducto/getPropiedadFamiliaProducto"), payload)
      let response = getResponse(request, null);

      if(response != null){
        this.tableData = response.propiedadFamiliaProducto;
      }
      else this.notifyMessage("danger", self.$t("app.promps.error"));

      this.$swal.close();
    },
    openItemAdd() {
      EventBus.$emit("propiedadFamiliaProductoAdd");
    },
    openItemEdit(item){
      EventBus.$emit("propiedadFamiliaProductoEdit", item);
    },
    async active(row){
      let request = await this.$http.put(route("PropiedadFamiliaProducto/active"), row);
      let response = getResponse(request, null);

      if(response) this.notifyMessage("success", this.$t("app.promps.save_success"));
      else
        this.notifyMessage("danger", this.$t("app.promps.error"));
    },
    searchAgain() {
      const options = {
        keys: ["nombrePropiedad"],
        threshold: 0.3,
        shouldSort: false
      };
      let fuseSearch = new Fuse(this.tableData, options);
      let result = this.tableData;
      if (this.searchQuery !== "") {
        result = fuseSearch
          .search(this.searchQuery)
          .map(result => result.item);
      }
      this.searchedData = result;
    }
  },
  mounted() {
    this.init();
    EventBus.$on("append-property", property => {
      this.tableData.push(property);
    });
    EventBus.$on("updated-complete", () => {
      this.init();
    });
  },
  watch: {
    searchQuery(value) {
      this.searchAgain();
    }
  }
}
</script>

<style>
.form-group .el-input__inner {
  padding: 10px 18px 10px 30px !important;
}
</style>
<style scoped>
.indicator {
  font-size: 30px;
}
.indicator.success {
  color: #18ce0f;
}
.indicator.danger {
  color: #ff3636;
}
</style>
